import scrollIntoView from 'scroll-into-view';
import { window, document } from '../../../../helpers/BrowserHelpers';
import { TABLE_CONTAINER_CLASSNAME } from '../../../../components/Database/components/Table';
var SCROLL_TYPES = {
  COLUMN: 'column',
  RECORD: 'record'
};
export default function ScrollPlugin() {
  var store = {};

  var removeKey = function removeKey(key) {
    delete store[key];
  };

  return [{
    queries: {
      getScrollTo: function getScrollTo(database, key) {
        return store[key];
      }
    },
    commands: {
      registerScrollColumnKey: function registerScrollColumnKey(database, key) {
        store[key] = {
          type: SCROLL_TYPES.COLUMN
        };
      },
      registerScrollRecordKey: function registerScrollRecordKey(database, key) {
        store[key] = {
          type: SCROLL_TYPES.RECORD
        };
      },
      scrollIfNeeded: function scrollIfNeeded(database, key, ref) {
        var scroll = database.getScrollTo(key);
        if (!scroll) return;
        removeKey(key);

        if (scroll.type === SCROLL_TYPES.COLUMN) {
          database.scrollInsideDatabase(ref);
        } else {
          //Record sometime need the note to be scrolled towards the bottom to display,
          database.scrollToRecord(ref);
        }
      },
      scrollToRecord: function scrollToRecord(database, element) {
        if (!element) return;
        var bounding = element.getBoundingClientRect();
        var elementIsInViewport = bounding.top >= 0 && bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);

        if (!elementIsInViewport) {
          scrollIntoView(element, {
            time: 300,
            align: {
              top: 1 //For rows, only scroll enough to see it, no need to center it

            }
          });
        }
      },
      scrollInsideDatabase: function scrollInsideDatabase(database, element) {
        if (!element) return;
        scrollIntoView(element, {
          time: 300,
          validTarget: function validTarget(target, parentsScrolled) {
            return target.matches && //window is also a match
            target.matches(".".concat(TABLE_CONTAINER_CLASSNAME)) //Only scroll the table, not the note or anything else
            ;
          }
        });
      }
    }
  }];
}